import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { ThemeProvider } from "@/context/ThemeProvider";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { CompareProvider } from "@/context/CompareContext";
import { CurrencyProvider } from "@/context/CurrencyContext";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Wishlist from "@/pages/Wishlist";
import Compare from "@/pages/Compare";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Collections from "@/pages/Collections";
import Partners from "@/pages/Partners";
import Resources from "@/pages/Resources";
import FAQ from "@/pages/FAQ";
import Testimonials from "@/pages/Testimonials";
import Contact from "@/pages/Contact";
import Repairs from "@/pages/Repairs";
import Servicing from "@/pages/Servicing";
import Rentals from "@/pages/Rentals";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <SettingsProvider>
          <AuthProvider>
            <CurrencyProvider>
              <CartProvider>
                <WishlistProvider>
                  <CompareProvider>
                    <BrowserRouter>
                      <Routes>
                        <Route element={<Layout />}>
                          <Route path="/" element={<Home />} />
                          <Route path="/shop" element={<Shop />} />
                          <Route path="/category/:category" element={<Shop />} />
                          <Route path="/accessories" element={<Shop forceCategory="components" />} />
                          <Route path="/product/:slug" element={<ProductDetail />} />
                          <Route path="/cart" element={<Cart />} />
                          <Route path="/checkout/success" element={<CheckoutSuccess />} />
                          <Route path="/wishlist" element={<Wishlist />} />
                          <Route path="/compare" element={<Compare />} />
                          <Route path="/about" element={<About />} />
                          <Route path="/blog" element={<Blog />} />
                          <Route path="/blog/:slug" element={<BlogPost />} />
                          <Route path="/collections/:name" element={<Collections />} />
                          <Route path="/partners" element={<Partners />} />
                          <Route path="/resources" element={<Resources />} />
                          <Route path="/faq" element={<FAQ />} />
                          <Route path="/testimonials" element={<Testimonials />} />
                          <Route path="/contact" element={<Contact />} />
                          <Route path="/repairs" element={<Repairs />} />
                          <Route path="/servicing" element={<Servicing />} />
                          <Route path="/rentals" element={<Rentals />} />
                          <Route path="/login" element={<Login />} />
                          <Route path="/register" element={<Register />} />
                          <Route path="/account" element={<Account />} />
                          <Route path="/admin" element={<Admin />} />
                          <Route path="/privacy" element={<Legal type="privacy" />} />
                          <Route path="/terms" element={<Legal type="terms" />} />
                          <Route path="/shipping" element={<Legal type="shipping" />} />
                          <Route path="/returns" element={<Legal type="returns" />} />
                          <Route path="/cookies" element={<Legal type="cookies" />} />
                          <Route path="*" element={<NotFound />} />
                        </Route>
                      </Routes>
                    </BrowserRouter>
                    <Toaster position="top-center" richColors />
                  </CompareProvider>
                </WishlistProvider>
              </CartProvider>
            </CurrencyProvider>
          </AuthProvider>
        </SettingsProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
